import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import api from "../../../api";

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port: ''
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            nombre: '',
            host: '',
            username: '',
            password: '',
            port: ''
        });
        if (this.props.onClose) this.props.onClose();
    }

    setSelects(data) {
        this.setState(() => ({
            nombre: data.nombre,
            host: data.host,
            username: data.username,
            password: data.password,
            port: data.port
        }));
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.email.casillas.detail}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Casilla de Mail"}
                buttonTitle={"Ver"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
                cancelButtonLabel="Cerrar"
                className="ui-modal-dialog"
            >
                <div className="ui-form">
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                className="form-control"
                                value={this.state.nombre}
                                disabled={true}
                            />
                        </div>
                        <div className="ui-field">
                            <label>Host</label>
                            <input
                                type="text"
                                name="host"
                                className="form-control"
                                value={this.state.host}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Usuario</label>
                            <input
                                type="text"
                                name="username"
                                className="form-control"
                                value={this.state.username}
                                disabled={true}
                            />
                        </div>
                        <div className="ui-field">
                            <label>Puerto</label>
                            <input
                                type="text"
                                name="port"
                                className="form-control"
                                value={this.state.port}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <label>Contraseña</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={this.state.password}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Detail.js